/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { StepProps, Text, TextColor, VFlow } from 'bold-ui'
import { VerticalStep, VerticalStepper } from 'components/vertical-stepper'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import {
  ConsultaSeguimentoAplicacaoItemModel,
  ConsultaSeguimentoAplicacaoModel,
  ConsultaSeguimentoModalTab,
} from '../model-consultaSeguimento'
import { ConsultaSeguimentoModalStepperPerguntaStatus } from './ConsultaSeguimentoModalStepperPerguntaStatus'

interface ConsultaSeguimentoModalStepperProps {
  perguntas: ConsultaSeguimentoAplicacaoModel
  status: ConsultaSeguimentoModalTab
}

export function ConsultaSeguimentoModalStepper(props: Readonly<ConsultaSeguimentoModalStepperProps>) {
  const { status, perguntas } = props

  const isAplicacao = status === ConsultaSeguimentoModalTab.APLICACAO
  const isSelecao = status === ConsultaSeguimentoModalTab.SELECAO
  const isResultado = status === ConsultaSeguimentoModalTab.RESULTADO

  const entrevistaSeguimentoStep = getEntrevistaSeguimentoStepDataByStatus(status)

  return (
    <VerticalStepper gap={isResultado ? 2 : 0}>
      <VerticalStep
        status={isSelecao ? 'active' : 'completed'}
        connectorStatus='incompleted'
        headerStyle={styles.stepHeader}
        connectorStyle={styles.stepConnector}
        header={<Text color={isSelecao ? 'primary' : 'normal'}>Seleção dos itens</Text>}
        body={
          isSelecao && <Text color='secondary'>Selecione os itens do M-CHAT-R que a criança falhou para iniciar.</Text>
        }
      />
      <VerticalStep
        status={entrevistaSeguimentoStep.status}
        connectorStatus='incompleted'
        headerStyle={styles.stepHeader}
        connectorStyle={styles.stepConnector}
        header={<Text color={entrevistaSeguimentoStep.textColor}>Entrevista de seguimento</Text>}
        body={
          isAplicacao && (
            <VFlow vSpacing={0} style={styles.stepContainer}>
              {Object.entries(perguntas).map(
                ([pergunta, values]: [MChatPerguntaEnum, ConsultaSeguimentoAplicacaoItemModel]) => (
                  <ConsultaSeguimentoModalStepperPerguntaStatus
                    key={pergunta}
                    pergunta={pergunta}
                    status={values.status}
                  />
                )
              )}
            </VFlow>
          )
        }
      />
      <VerticalStep
        status={isResultado ? 'active' : 'incompleted'}
        header={<Text color={isResultado ? 'primary' : 'secondary'}>Resultado final</Text>}
        headerStyle={styles.stepHeader}
        hasConnector={false}
      />
    </VerticalStepper>
  )
}

function getEntrevistaSeguimentoStepDataByStatus(
  status: ConsultaSeguimentoModalTab
): { status: StepProps['status']; textColor: TextColor } {
  if (status === ConsultaSeguimentoModalTab.SELECAO) {
    return {
      status: 'incompleted',
      textColor: 'secondary',
    }
  } else if (status === ConsultaSeguimentoModalTab.APLICACAO) {
    return {
      status: 'active',
      textColor: 'primary',
    }
  } else {
    return {
      status: 'completed',
      textColor: 'normal',
    }
  }
}

const styles = {
  stepHeader: css`
    min-height: 2rem;
    height: 2rem;
  `,
  stepConnector: css`
    top: 1.5rem;
    height: calc(100% - 1rem);
  `,
  stepContainer: css`
    margin-top: 0.25rem;
  `,
}
